import { createReducer } from 'typesafe-actions';
import { owners, setOwner } from './actions';
import { GetOwnersResponse, Owner } from './types';
import { RequestStatus } from 'utils/types';

type State = {
  data: GetOwnersResponse[] | null;
  message: string | null;
  owner: Owner | null;
  status: RequestStatus | null;
};

const initialState: State = {
  data: null,
  message: null,
  owner: null,
  status: null,
};

const ownersReducer = createReducer(initialState)
  .handleAction(owners.request, (state) => ({
    ...state,
    data: null,
    message: null,
    status: RequestStatus.PENDING,
  }))
  .handleAction(owners.success, (state, action) => ({
    ...state,
    data: [
      ...action.payload,
    ],
    message: null,
    status: RequestStatus.SUCCESS,
  }))
  .handleAction(owners.failure, (state, action) => ({
    ...state,
    data: null,
    message: action.payload.message,
    status: RequestStatus.FAILED,
  }))
  .handleAction(setOwner, (state, action) => ({
    ...state,
    owner: action.payload
  }))

export default ownersReducer;
